<template>
  <div class="container-fluid h-100">
    <div class="content-register" id="content1-register">
      <h3 style="font-family:'GothamBoldItalic'">Completa tu registro con tu cuenta de Google llenando la información del formulario</h3>
      <div
        class="row justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-center justify-content-xl-center align-items-center h-100"
      >
        <div class="col-12 col-md-12 col-lg-6 col-xl-5 col-sm-12 padding-t2">
          <h1 class="club">ÚNETE AL MOTOCLUB.</h1>
          <p class="ingresa">
            Ingresa tus datos para terminar de crear tu cuenta en el club <br> y poder registrar
            tus códigos.
          </p>
        </div>

        <div class=" col-12 col-md-12 col-lg-6 col-xl-7 col-sm-12  ">
          <div class="row p-row mt-3">
            <div class="col-12 small-info">
              <small
                >Recuerda que los datos marcados con (*) son obligatorios</small
              >
            </div>
            <div class="col-12 col-md-12 col-lg-4 col-xl-4 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3 ">
                  <select
                    v-model="form.documentType"
                    class="form-control color-input select-input"
                    :class="{ 'is-danger': errors.documentType }"
                    id="exampleFormControlSelect1"
                    placeholder="Tipo de documento *"
                  >
                    <option value="0" disabled selected
                      >Tipo de documento *</option
                    >
                    <option
                      v-for="(item, i) in listTypeDocuments"
                      :key="'td' + i"
                      :value="item.id"
                      class="color-option"
                      >{{ item.name }}
                    </option>
                  </select>
                </div>
                <span
                  v-if="errors.documentType"
                  class="text-danger float-left small error-danger"
                  >{{ errors.documentType }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-4 col-xl-5 col-sm-12">
              <div class="form-group">
                <div class="input-group  mb-3">
                  <input
                    v-model="form.documentNumber"
                    type="text"
                    class="form-control color-input"
                    :class="{ 'is-danger': errors.documentNumber }"
                    aria-label="document"
                    placeholder="Número de documento * "
                    aria-describedby="basic-addon1"
                  />
                </div>
                <span
                  v-if="errors.documentNumber"
                  class="text-danger float-left small error-danger"
                  >{{ errors.documentNumber }}</span
                >
              </div>
            </div>

            <div class="col-12 col-md-12 col-lg-4 col-xl-3 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3 ">
                  <select
                    v-model="form.genderId"
                    class="form-control color-input select-input"
                    :class="{ 'is-danger': errors.genderId }"
                    id="exampleFormControlSelect1"
                    placeholder="Genero *"
                  >
                    <option value="0" disabled selected>Género *</option>
                    <option
                      v-for="(item, i) in listGenders"
                      :key="'td' + i"
                      :value="item.id"
                      class="color-option"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <span
                  v-if="errors.genderId"
                  class="text-danger float-left small error-danger"
                  >{{ errors.genderId }}</span
                >
              </div>
            </div>

            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3">
                  <input
                    :class="{ 'is-danger': errors.name }"
                    v-model="dataUser.name"
                    type="text"
                    class="form-control color-input"
                    aria-label="name"
                    placeholder="Nombres *"
                    aria-describedby="basic-addon1"
                  />
                </div>
                <span
                  v-if="errors.name"
                  class="text-danger float-left small error-danger"
                  >{{ errors.name }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3">
                  <input
                    :class="{ 'is-danger': errors.lastName }"
                    v-model="dataUser.last_name"
                    type="text"
                    class="form-control color-input"
                    aria-label="lastName"
                    placeholder="Apellidos *"
                    aria-describedby="basic-addon1"
                  />
                </div>
                <span
                  v-if="errors.lastName"
                  class="text-danger float-left small error-danger"
                  >{{ errors.lastName }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <div class="input-group  mb-3">
                  <select
                    v-model="form.state"
                    class="form-control color-input select-input"
                    :class="{ 'is-danger': errors.state }"
                    id="exampleFormControlSelect1"
                  >
                    <option disabled value="0" selected>Departamento *</option>
                    <option
                      v-for="(item, i) in listDocuments"
                      :value="item.id"
                      class=" color-option"
                      :key="'st' + i"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <span
                  v-if="errors.state"
                  class="text-danger float-left small error-danger"
                  >{{ errors.state }}</span
                >
              </div>
            </div>

            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3">
                  <select
                    v-model="form.cityId"
                    :disabled="showCities"
                    class="form-control color-input select-input"
                    :class="{ 'is-danger': errors.cityId }"
                    id="exampleFormControlSelect1"
                  >
                    <option value="0" disabled selected>Ciudad *</option>
                    <option
                      v-for="(item, i) in listCities"
                      :key="'ci' + i"
                      :value="item.id"
                      class=" color-option"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <span
                  v-if="errors.cityId"
                  class="text-danger float-left small error-danger"
                  >{{ errors.cityId }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3">
                  <input
                    :class="{ 'is-danger': errors.phone }"
                    type="text"
                    v-model="form.phone"
                    class="form-control color-input"
                    aria-label="phone"
                    placeholder="Teléfono *"
                    aria-describedby="basic-addon1"
                  />
                </div>
                <span
                  v-if="errors.phone"
                  class="text-danger float-left small error-danger"
                  >{{ errors.phone }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3">
                  <input
                    :class="{ 'is-danger': errors.email }"
                    v-model="dataUser.email"
                    type="text"
                    class="form-control color-input"
                    aria-label="email"
                    placeholder="email *"
                    aria-describedby="basic-addon1"
                  />
                </div>
                <span
                  v-if="errors.email"
                  class="text-danger float-left small error-danger"
                  >{{ errors.email }}</span
                >
              </div>
            </div>

            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3">
                  <input
                    :class="{ 'is-danger': errors.birthdate }"
                    type="text"
                    v-model="form.birthdate"
                    class="form-control color-input"
                    placeholder="fecha de nacimiento *"
                    :min="minDate()"
                    :max="maxDate()"
                    onfocus="(this.type='date')"
                  />
                </div>
                <span
                  v-if="errors.birthdate"
                  class="text-danger float-left small error-danger"
                  >{{ errors.birthdate }}</span
                >
              </div>
            </div>

            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3">
                  <select
                      v-model="form.motorcycleBrand"
                      class="form-control color-input select-input"
                      :class="{ 'is-danger': errors.motorcycleBrand }"
                      id="motorcycleBrand"
                  >
                    <option value="0" disabled selected>Marca de tu Moto *</option>
                    <option v-for="(item, i) in listBrands"  :value="item.id" class="color-option" >
                      {{ item.description }}
                    </option>
                  </select>
                </div>
                <span
                    v-if="errors.motorcycleBrand"
                    class="text-danger float-left small error-danger"
                >{{ errors.motorcycleBrand }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12"
                 v-if="form.motorcycleBrand == 44"
              >
              <div class="form-group">
                <div class="input-group mb-3">
                  <input
                      :class="{ 'is-danger': errors.motorcycleBrandOther }"
                      v-model="form.motorcycleBrandOther"
                      type="text"
                      class="form-control color-input"
                      aria-label="text"
                      placeholder="¿Cúal? (Escriba la marca de su moto) *"
                      aria-describedby="basic-addon1"
                  />
                </div>
                <span
                    v-if="errors.motorcycleBrandOther"
                    class="text-danger float-left small error-danger"
                >{{ errors.motorcycleBrandOther }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3">
                  <select
                      v-model="form.motorcycleCylinder"
                      class="form-control color-input select-input"
                      :class="{ 'is-danger': errors.motorcycleCylinder }"
                      id="motorcycleCylinder"
                  >
                    <option value="0" disabled selected>Cilindraje de tu Moto *</option>
                    <option v-for="(item, i) in listCylinders"  :value="item.id" class="color-option" >
                      {{ item.description }}
                    </option>
                  </select>
                </div>
                <span
                    v-if="errors.motorcycleCylinder"
                    class="text-danger float-left small error-danger"
                >{{ errors.motorcycleCylinder }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3">
                  <select
                      v-model="form.motorcycleUse"
                      class="form-control color-input select-input"
                      :class="{ 'is-danger': errors.motorcycleUse }"
                      id="motorcycleUse"
                  >
                    <option value="0" disabled selected>Uso de tu Moto *</option>
                    <option v-for="(item, i) in listUses"  :value="item.id" class="color-option" >
                      {{ item.description }}
                    </option>
                  </select>
                </div>
                <span
                    v-if="errors.motorcycleUse"
                    class="text-danger float-left small error-danger"
                >{{ errors.motorcycleUse }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12"
                 v-if="form.motorcycleUse == 4"
            >
              <div class="form-group">
                <div class="input-group mb-3">
                  <input
                      :class="{ 'is-danger': errors.motorcycleUseOther }"
                      v-model="form.motorcycleUseOther"
                      type="text"
                      class="form-control color-input"
                      aria-label="text"
                      placeholder="¿Cúal? (Escriba el uso de su moto) *"
                      aria-describedby="basic-addon1"
                  />
                </div>
                <span
                    v-if="errors.motorcycleUseOther"
                    class="text-danger float-left small error-danger"
                >{{ errors.motorcycleUseOther }}</span
                >
              </div>
            </div>

            <div
              class="col-12 col-md-12 col-lg-12 col-xl-12 col-sm-12"
              style="text-align: left;"
            >
              <label class="password-text"
                >Crea una nueva contraseña para ingresar al club</label
              >
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3">
                  <input
                    :class="{ 'is-danger': errors.pass }"
                    v-model="form.pass"
                    type="password"
                    class="form-control color-input"
                    aria-label="password"
                    placeholder="Contraseña *"
                    aria-describedby="basic-addon1"
                  />
                </div>

                <span
                  v-if="errors.pass"
                  class="text-danger float-left small error-danger"
                  >{{ errors.pass }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3">
                  <input
                    :class="{ 'is-danger': errors.passCon }"
                    v-model="form.passCon"
                    type="password"
                    class="form-control color-input"
                    aria-label="passwordC"
                    placeholder="Confirmar contraseña *"
                    aria-describedby="basic-addon1"
                  />
                </div>
                <span
                  v-if="errors.passCon"
                  class="text-danger float-left small error-danger"
                  >{{ errors.passCon }}</span
                >
              </div>
            </div>

            <div class="col-12 col-md-12 col-lg-12 col-xl-12 col-sm-12">
              <table class="mb-2 table-register">
                <tr hidden>
                  <th id="au-1">Acción</th>
                  <th id="au-2">Texto</th>
                </tr>
                <tr>
                  <td>
                    <input
                      :class="{ 'is-danger': errors.check }"
                      v-model="form.check"
                      style="cursor: pointer"
                      type="checkbox"
                      name="checkbox"
                      id="checkbox1"
                    />
                  </td>
                  <td class="pl-3" style="text-align: left">
                    <a class="condiciones" :href="file" target="_blank"
                      ><label> Acepta términos y condiciones *</label></a
                    >
                    <br />
                    <span
                      v-if="errors.check"
                      class=" text-danger float-left small error-danger "
                      style="padding-top: 11px;"
                      >{{ errors.check }}</span
                    >
                  </td>
                </tr>
                <tr>
                  <td>
                    <input
                      v-model="form.checkMail"
                      type="checkbox"
                      name="checkbox"
                      id="checkbox1"
                    />
                  </td>
                  <td class="pl-3" style="text-align: left">
                    Me gustaría recibir noticias sobre productos y servicios de
                    Havoline Motoclub Te Cubre a través de e-mail y SMS.
                  </td>
                </tr>
              </table>

              <button
                :disabled="disableLoading"
                type="button"
                @click="updateInfoUser()"
                class="btn btn-danger btn-sm btn-block btn-register"
                id="btn-register-id"
              >
                <span
                  v-if="disableLoading"
                  class="spinner-border spinner-border-md"
                  role="status"
                  aria-hidden="true"
                ></span>
                <template v-else>COMPLETAR REGISTRO</template>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "contentLanding",
  data() {
    return {
      dataUser: [],
      data: {},
      listBrands: [],
      listCylinders: [],
      listUses: [],
      listGenders: [],
      listDistributor: [],
      showProfiles: {
        classBiker: "btn-danger",
        classLubricator: "btn-danger",
        biker: true,
        lubricator: true,
      },
      listDocuments: [],
      listCities: [],
      listTypeDocuments: [],
      form: {
        distributorId: 0,
        documentType: 0,
        documentNumber: "",
        genderId: 0,
        name: "",
        lastName: "",
        state: 0,
        cityId: 0,
        phone: "",
        email: "",
        birthdate: null,
        motorcycleBrand: 0,
        motorcycleBrandOther: "",
        motorcycleCylinder: 0,
        motorcycleUse: 0,
        motorcycleUseOther: "",
        pass: "",
        passCon: "",
        check: false,
        checkMail: false,
      },
      errors: {
        distributorId: false,
        documentType: false,
        documentNumber: false,
        genderId: 0,
        name: false,
        lastName: false,
        state: false,
        cityId: false,
        phone: false,
        email: false,
        birthdate: false,
        motorcycleBrand: 0,
        motorcycleBrandOther: "",
        motorcycleCylinder: 0,
        motorcycleUse: 0,
        motorcycleUseOther: "",
        pass: false,
        passCon: false,
        check: false,
      },
      showCities: true,
      disableLoading: false,
      file: null,
    };
  },
  methods: {
    minDate() {
      const now = new Date();
      now.setFullYear(now.getFullYear() - 100);
      return now.toISOString().substr(0, 10);
    },
    maxDate(){
      const now = new Date();
      now.setFullYear(now.getFullYear() - 18);
      return now.toISOString().substr(0, 10);
    },
    getDataUser() {
        var app = this;
        axios
        .get("api/showUser")
        .then(function(res) {
          app.dataUser = res.data.User;
          // console.log('app.dataUser: ', JSON.stringify(app.dataUser));
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getInfoUser(){
        this.data = {
          name: this.dataUser.name,
          lastName: this.dataUser.last_name,
          email: this.dataUser.email,
        };
        Object.assign(
          this.form,
          this.data
        );
        // console.log('this.form: ', JSON.stringify(this.form));
    },
    getTypeDocuments() {
      var app = this;
      axios
        .get("api/documentTypeController")
        .then(function(res) {
          app.listTypeDocuments = res.data.TypeDocument;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    getBrands() {
      axios
          .get("api/motorcycleBrands/get")
          .then((res) => {
            if (res.data.cod == 0) {
              this.listBrands = res.data.data;
            }
          })
          .catch((error) => {
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: error.response.data.message,
            });
          });
    },
    getMotorcycleUses() {
      axios
          .get("api/motorcycleUses/get")
          .then((res) => {
            if (res.data.cod == 0) {
              this.listUses = res.data.data;
            }
          })
          .catch((error) => {
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: error.response.data.message,
            });
          });
    },
    getMotorcycleCylinder() {
      axios
          .get("api/motorcycleCylinder/get")
          .then((res) => {
            if (res.data.cod == 0) {
              this.listCylinders = res.data.data;
            }
          })
          .catch((error) => {
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: error.response.data.message,
            });
          });
    },
    getGenders() {
      axios
        .get("api/getGenders")
        .then((res) => {
          if (res.data.cod == 0) {
            this.listGenders = res.data.data;
          }
        })
        .catch((error) => {
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        });
    },
    getDocuments() {
      axios
        .get("api/files/active/" + 1)
        .then((res) => {
          if (res.data.cod == 0) {
            this.file = res.data.data[0].url;
          }
        })
        .catch((error) => {
          console.log(error.response);
        });
    },
    distributorList() {
      var app = this;
      axios
        .get("api/distributorList")
        .then(function(res) {
          if (res.data.cod == 0) {
            app.listDistributor = res.data.data;
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    irCode() {
      let sesion = sessionStorage.getItem("token");
      if (sesion == "" || sesion == null) {
        this.$router.push({ name: "login" });
      } else {
        this.$router.push({ name: "homeUser" });
      }
    },
    getListStates() {
      var app = this;
      axios
        .get("api/getStates")
        .then(function(res) {
          app.listDocuments = res.data.states;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    getCities(stateId) {
      var app = this;
      var data = {
        stateId: stateId,
      };
      axios
        .post("api/showCity", data)
        .then(function(res) {
          app.showCities = false;
          app.listCities = res.data.cities;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    validform() {
      this.getInfoUser();
      let app = this;
      
      if (!app.form.documentType) {
        app.errors.documentType = "El tipo de documento es requerido.";
        return false;
      }
      if (!app.form.documentNumber) {
        app.errors.documentNumber = "El númnero de documento es requerido.";
        return false;
      }
      if (!app.form.genderId) {
        app.errors.genderId = "El género es requerido.";
        return false;
      }
      if (!app.data.name) {
        app.errors.name = "El nombre es requerido.";
        return false;
      }
      if (!app.data.lastName) {
        app.errors.lastName = "Los apellidos son requeridos.";
        return false;
      }
      if (!app.form.state) {
        app.errors.state = "El departamento es requerido.";
        return false;
      }
      if (!app.form.cityId) {
        app.errors.cityId = "La ciudad es requerida.";
        return false;
      }
      if (!app.form.phone) {
        app.errors.phone = "El número de teléfono es requerido.";
        return false;
      }
      if (!app.data.email) {
        app.errors.email = "El email es requerido.";
        return false;
      }
      if (!app.form.birthdate) {
        app.errors.birthdate = "La fecha de nacimiento es requerida.";
        return false;
      }
      if (app.form.motorcycleBrand == 0) {
        app.errors.motorcycleBrand = "La marca de tu moto es requerida.";
        return false;
      }
      if (app.form.motorcycleBrand == 44) {
        if (!app.form.motorcycleBrandOther) {
          app.errors.motorcycleBrandOther = "La marca de tu moto es requerida.";
          return false;
        }
      }
      if (app.form.motorcycleCylinder == 0) {
        app.errors.motorcycleCylinder = "El cilindraje de tu moto es requerido.";
        return false;
      }
      if (app.form.motorcycleUse == 0) {
        app.errors.motorcycleUse = "El uso de tu moto es requerido.";
        return false;
      }
      if (app.form.motorcycleUse == 4) {
        if(!app.form.motorcycleUseOther){
          app.errors.motorcycleUseOther = "El uso de tu moto es requerido.";
          return false;
        }
      }
      if (!app.form.pass) {
        app.errors.pass = "La contraseña es requerida.";
        return false;
      }
      if (!app.form.passCon) {
        app.errors.passCon = "La contraseña es requerida.";
        return false;
      }
      if (app.form.passCon != this.form.pass) {
        app.errors.passCon = "Las contraseñas deben ser iguales";
        return false;
      }
      if (!app.form.check) {
        app.errors.check = "Debe aceptar términos y condiciones";
        return false;
      }
      if (
        !app.errors.documentType &&
        !app.errors.documentNumber &&
        !app.errors.genderId &&
        !app.errors.name &&
        !app.errors.lastName &&
        !app.errors.state &&
        !app.errors.cityId &&
        !app.errors.phone &&
        !app.errors.email &&
        !app.errors.birthdate &&
        app.form.motorcycleBrand &&
        !app.form.motorcycleBrandOther &&
        app.form.motorcycleCylinder &&
        app.form.motorcycleUse &&
        !app.form.motorcycleUseOther &&
        !app.errors.pass &&
        !app.errors.passCon &&
        !app.errors.check &&
        !app.validEmail(app.errors.email) &&
        !app.validPhone(app.errors.phone) &&
        // !app.validPlate(app.errors.plate) &&
        !app.validPassword(app.errors.pass)
      ) {
        return true;
      }
      return false;
    },
    validEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validPhone(phone) {
      var re = /^[0-9]{7,10}$/;
      return re.test(phone);
    },
    validPassword(pass) {
      var re = /^(?=\w*\d)(?=\w*[A-Z])(?=\w*[a-z])\S{8,16}$/;
      return re.test(pass);
    },
    updateInfoUser() {
      // var code = this.$route.params.code;
      var campaign = this.$route.query.utm_campaign;
      var source = this.$route.query.utm_source;
      var mediun = this.$route.query.utm_medium;
      if (campaign != undefined) {
        this.form.campaign = campaign;
      }
      if (source != undefined) {
        this.form.source = source;
      }
      if (mediun != undefined) {
        this.form.mediun = mediun;
      }
      if (this.form.checkMail) {
        this.form.checkMail = 1;
      } else {
        this.form.checkMail = 0;
      }
      if (this.form.checkMail) {
        this.form.checkMail = 1;
      } else {
        this.form.checkMail = 0;
      }

      if (this.validform()) {
        var app = this;
        app.disableLoading = true;
        axios
        .post("api/updateLoginGoogle", this.form)
        .then(function(res) {
          app.disableLoading = false;
          if (res.data.cod == 0) {
            localStorage.setItem('sms', res.data.message);
            app.$router.push({ name: "profileUser" });
          } else if (res.data.ResponseCode === 3) {
            app.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: res.data.ResponseMessage,
            });
          } else {
            app.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: "Error al registrar la información",
            });
          }
        })
        .catch(function(error) {
          app.disableLoading = false;
          app.$swal({
            icon: "error",
            title: "Oops...",
            text: "Error al registrar la información",
          });
        });
      }
    },
  },
  watch: {
    "form.distributorId": function(n) {
      if (n != 0) {
        this.errors.distributorId = false;
      } else {
        this.errors.distributorId = "El distribuidor es requerido.";
      }
    },
    "form.documentType": function(n) {
      if (n != 0) {
        this.errors.documentType = false;
      } else {
        this.errors.documentType = "El tipo de documento es requerido.";
      }
    },
    "form.documentNumber": function(n) {
      if (n) {
        this.errors.documentNumber = false;
      } else {
        this.errors.documentNumber = "El número de documento es requerido.";
      }
    },
    "form.genderId": function(n) {
      if (n != 0) {
        this.errors.genderId = false;
      } else {
        this.errors.genderId = "El género es requerido.";
      }
    },
    "data.name": function(n) {
      if (n) {
        this.errors.name = false;
      } else {
        this.errors.name = "El nombre es requerido.";
      }
    },
    "data.lastName": function(n) {
      if (n) {
        this.errors.lastName = false;
      } else {
        this.errors.lastName = "Los apellido son requeridos.";
      }
    },
    "form.state": function(n) {
      this.getCities(n);
      if (n == 0) {
        this.errors.state = "El departamento es requerido.";
      } else {
        this.errors.state = false;
      }
    },
    "form.cityId": function(n) {
      if (n != 0) {
        this.errors.cityId = false;
      } else {
        this.errors.cityId = "La ciudad es requerida.";
      }
    },
    "form.phone": function(n) {
      if (!n) {
        this.errors.phone = "El teléfono es requerido.";
      } else if (!this.validPhone(n)) {
        this.errors.phone = "El teléfono es inválido.";
      } else {
        this.errors.phone = false;
      }
    },
    "data.email": function(n) {
      if (!n) {
        this.errors.email = "El email es requerido.";
      } else if (!this.validEmail(n)) {
        this.errors.email = "El email es inválido.";
      } else {
        this.errors.email = false;
      }
    },
    "form.birthdate": function(n) {
      if (n != 0) {
        this.errors.birthdate = false;
      } else {
        this.errors.birthdate = "La fecha de nacimiento es requerida.";
      }
    },
    "form.motorcycleBrand": function(n) {
      if (n != 0) {
        this.errors.motorcycleBrand = false;
      } else {
        this.errors.motorcycleBrand = "La marca de tu moto es requerida.";
      }
    },
    "form.motorcycleBrandOther": function(n) {
      if (n) {
        this.errors.motorcycleBrandOther = false;
      } else {
        this.errors.motorcycleBrandOther = "La marca de tu moto es requerida.";
      }
    },
    "form.motorcycleCylinder": function(n) {
      if (n != 0) {
        this.errors.motorcycleCylinder = false;
      } else {
        this.errors.motorcycleCylinder = "El cilindraje de tu moto es requerido.";
      }
    },
    "form.motorcycleUse": function(n) {
      if (n != 0) {
        this.errors.motorcycleUse = false;
      } else {
        this.errors.motorcycleUse = "El uso de tu moto es requerido.";
      }
    },
    "form.motorcycleUseOther": function(n) {
      if (n) {
        this.errors.motorcycleUseOther = false;
      } else {
        this.errors.motorcycleUseOther = "El uso de tu moto es requerido.";
      }
    },
    "form.pass": function(n) {
      if (!n) {
        this.errors.pass = "La contraseña es requerida.";
      } else if (!this.validPassword(n)) {
        this.errors.pass =
          "La contraseña es inválida, debe tener entre 8 a 16 carácteres, al menos un dígito, al menos una minúscula y al menos una mayúscula. Puede tener otros símbolos.";
      } else {
        this.errors.pass = false;
      }
      if (this.form.passCon == this.form.pass) {
        this.errors.passCon = false;
      } else {
        this.errors.passCon = "Las contraseñas deben ser iguales";
      }
    },
    "form.passCon": function() {
      if (this.form.passCon == this.form.pass) {
        this.errors.passCon = false;
      } else {
        this.errors.passCon = "Las contraseñas deben ser iguales";
      }
    },
    "form.check": function() {
      if (!this.form.check) {
        this.errors.check = "Debe aceptar términos y condiciones";
      } else {
        this.errors.check = false;
      }
    },
  },
  created() {
    console.log(sessionStorage.getItem("infoUser"));
  },
  mounted() {
    this.getGenders();
    this.getDocuments();
    this.distributorList();
    this.getListStates();
    this.getTypeDocuments();
    this.getBrands();
    this.getMotorcycleUses();
    this.getMotorcycleCylinder();
    this.getDataUser();
    this.getInfoUser();
  },
};
</script>

<style scope>
.content-register {
  padding-left: 5%;
  padding-top: 10%;
  padding-bottom: 10%;
  height: 100%;
}

.table-register {
  margin-left: 10%;
}

.small-register {
  font-family: "GothamBoldItalic" !important;
}

.club {
  font-size: 55px;
  font-family: "Gotham-UltraItalic";
  text-align: left;
}

.password-text {
  font-family: "GothamBoldItalic";
}

.ingresa {
  font-size: 18px;
  text-align: left;
  font-family: "GothamBookItalic";
}

.t-c {
  text-align: center;
}

#content1-register {
  background-size: cover;
  background-image: url("../../assets/img/03.jpg");
  background-position: center center;
  background-attachment: fixed;
  background-color: "#171717";
}

.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  padding-right: 0px !important;
  padding-left: 0px !important;
  overflow: hidden;
}

.color-login {
  background-color: #ffffff00 !important;
  border: solid 0px !important;
}

a.condiciones {
  text-align: left !important;
  cursor: pointer !important;
  color: white;
  border-bottom: 1px solid;
}

.font-none {
  font-family: "Arial";
}

.condiciones:hover {
  color: #b3b3b3 !important;
  /* border-bottom: 1px solid; */
}

.color-input {
  font-size: 13px;
  background-color: #ffffff00 !important;
  height: 30px !important;
  color: #fff !important;
  position: relative;
  padding: 0px 15px !important;
}

.color-select {
  font-size: 13px;
  height: 30px !important;
  position: relative;
  padding: 0px 15px !important;
}

.color-input:disabled {
  /* opacity: 0 !important; */
  border-color: #676565 !important;
  color: #676565 !important;
}

.is-danger {
  border: solid 2px !important;
  border-color: #e9434c !important;
}

.error-danger {
  text-align: left !important;
  padding-bottom: 17px !important;
  margin-top: -15px !important;
}

.color-input::placeholder {
  color: white !important;
}

.color-option {
  color: black !important;
}

.color-option:active {
  background-color: crimson !important;
}

.icon-disable {
  color: #676565 !important;
}

.input-code:disabled {
  opacity: 0 !important;
  border-color: #000000 !important;
}

.small-info {
  text-align: left !important;
  color: #fff !important;
  font-size: 16px !important;
}

.icon::before {
  position: absolute;
  top: 25%;
  left: 5%;
}

@font-face {
  font-family: "Gotham-UltraItalic";
  src: url("./../../assets/font/Gotham-UltraItalic.ttf");
  font-display: swap;
}

@font-face {
  font-family: "GothamBoldItalic";
  src: url("./../../assets/font/GothamBoldItalic.ttf");
  font-display: swap;
}

@font-face {
  font-family: "GothamBookItalic";
  src: url("./../../assets/font/GothamBookItalic.ttf");
  font-display: swap;
}

/* LAPTOP NORMAL */

@media (max-width: 1200px) {
  .color-input {
    padding: 0px 15px !important;
  }
  .content-register {
    height: 100%;
  }
}

/* TABLET */

@media (max-width: 1023px) {
  .content-register {
    height: 100%;
  }

  .padding-t2 {
    padding-top: 13%;
    padding-bottom: 8%;
  }
}

/* MOBILE */
@media (max-width: 767px) {
  .p-row {
    padding-bottom: 1% !important;
  }

  .table-register {
    margin-left: 0%;
  }

  .content-register {
    padding-left: 0%;
    padding-top: 50%;
    padding-bottom: 30%;
  }

  .club {
    font-size: 40px;
    text-align: left;
  }

  .ingresa {
    font-size: 18px;
    text-align: left;
  }

  .margin-btn {
    margin-bottom: 35%;
  }
}
</style>
